import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const Ellipse: React.FC<IIconProps> = ({
  size = IconSizes.md,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={IconWidth[size]}
      className={UNSAFE_className || ''}
      {...props}
      height={IconHeight[size]}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Live area">
        <path
          d="M4.15384 9.04932C3.87884 9.04932 3.64345 8.95137 3.44767 8.75548C3.25178 8.55971 3.15384 8.32432 3.15384 8.04932C3.15384 7.77432 3.25178 7.53893 3.44767 7.34315C3.64345 7.14726 3.87884 7.04932 4.15384 7.04932C4.42884 7.04932 4.66428 7.14726 4.86017 7.34315C5.05595 7.53893 5.15384 7.77432 5.15384 8.04932C5.15384 8.32432 5.05595 8.55971 4.86017 8.75548C4.66428 8.95137 4.42884 9.04932 4.15384 9.04932ZM8.00001 9.04932C7.72501 9.04932 7.48962 8.95137 7.29384 8.75548C7.09795 8.55971 7.00001 8.32432 7.00001 8.04932C7.00001 7.77432 7.09795 7.53893 7.29384 7.34315C7.48962 7.14726 7.72501 7.04932 8.00001 7.04932C8.27501 7.04932 8.5104 7.14726 8.70617 7.34315C8.90206 7.53893 9.00001 7.77432 9.00001 8.04932C9.00001 8.32432 8.90206 8.55971 8.70617 8.75548C8.5104 8.95137 8.27501 9.04932 8.00001 9.04932ZM11.8462 9.04932C11.5712 9.04932 11.3357 8.95137 11.1398 8.75548C10.9441 8.55971 10.8462 8.32432 10.8462 8.04932C10.8462 7.77432 10.9441 7.53893 11.1398 7.34315C11.3357 7.14726 11.5712 7.04932 11.8462 7.04932C12.1212 7.04932 12.3566 7.14726 12.5523 7.34315C12.7482 7.53893 12.8462 7.77432 12.8462 8.04932C12.8462 8.32432 12.7482 8.55971 12.5523 8.75548C12.3566 8.95137 12.1212 9.04932 11.8462 9.04932Z"
          fill="black"
        />
      </g>
    </svg>
  );
};

export default Ellipse;
